import { render, staticRenderFns } from "./Gudingweizhi.vue?vue&type=template&id=22fb2bdf&scoped=true&"
import script from "./Gudingweizhi.vue?vue&type=script&lang=js&"
export * from "./Gudingweizhi.vue?vue&type=script&lang=js&"
import style0 from "./Gudingweizhi.vue?vue&type=style&index=0&id=22fb2bdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb2bdf",
  null
  
)

export default component.exports